import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { Body } from 'syf-component-library/ui/typography';
import ScreenMessage from '../../../modal/content/utils/ErrorMessage';
import { ConfigContext } from '../../../context';
import { translate } from '../../../strings/i18n';
import getImages from '../../../modal/content/helpers/get-images';
const ConfirmedUserAdded = () => {
    const { config } = useContext(ConfigContext);
    const { ladySuccess } = getImages({ config });
    return (_jsx(ScreenMessage, { image: ladySuccess, id: "mch-first-name-business-error", title: translate('successfulMessageBox.title'), subTitle: _jsxs(_Fragment, { children: [translate('successfulMessageBox.subtitle'), _jsx(Body, { isInline: true, weight: "bold", children: translate('successfulMessageBox.bold') })] }) }));
};
export default ConfirmedUserAdded;
